import { ISeoPageData } from '../../types/seo/pageData';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ESeoActionType, TSetPageDataAction } from './types';

export const setSeoPageData: (data: ISeoPageData | null) => TSetPageDataAction = actionGenerator<
  ESeoActionType.SetPageData,
  ISeoPageData | null
>(ESeoActionType.SetPageData);
